export default {"src":"/_next/static/media/closeNavButton.7b997501.svg","height":50,"width":61,"blurWidth":0,"blurHeight":0};